// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tour-stats[data-v-176c46ac]{margin:16px 0;padding-bottom:24px}.icon-group[data-v-176c46ac]{display:grid;grid-gap:48px;gap:48px;grid-template-columns:repeat(4,fit-content(100%));justify-items:start;@media (max-width:768px){grid-template-columns:repeat(2,1fr);grid-gap:12px;gap:12px;margin-top:8px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
